import { Modal } from "shared/ui/modal";
import { Button } from "shared/ui/button";
import styles from "./RecordDeleteConfirmModal.module.scss";

export const RecordDeleteSuccessModal = ({
  isModalOpen,
  open,
  close,
  toggle,
  event,
  onConfirm,
}) => {
  return (
    <Modal isModalOpen={isModalOpen} open={open} close={close} toggle={toggle}>
      <div className={styles.modalContent}>
        <p className={styles.modalContent__title}>
          Запись на мероприятие отменена
        </p>
        <div className={styles.modalContent__button}>
          <Button variant="primary" size="large" onClick={close}>
            Закрыть
          </Button>
        </div>
      </div>
    </Modal>
  );
};
